//    ╔═╗┌─┐┌┐┌┌─┐┬ ┬┌┬┐┌─┐  ┌┬┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐  ┬ ┬┌─┐┌┐
//    ║  │ ││││└─┐│ │││││ │   ││├┤   └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐  │││├┤ ├┴┐
//    ╚═╝└─┘┘└┘└─┘└─┘┴ ┴└─┘  ─┴┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘  └┴┘└─┘└─┘

import {Injectable} from '@angular/core';
import {LogEmisor} from '../modelo/LogEmisor';
import {Headers, Http} from '@angular/http';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {UtilConfig} from "../../../../../../autenticacion/servicios/UtilConfig";
import {WebServices} from "../../../../../recursos/modelo/consumerModel/web-services.enum";

declare var $: any;

@Injectable()
export class LogEmisorService {
    URL_LIST_LOG = "/log/customer/buscar";
    URL_GET_LOG = "/log/customer/consultar";
    URL_GET_ARCHIVO = "/log/customer/descargar";
    URL_GET_COMBOS = "/reporte/obtenerCombos";
    URL_LIST_DASHBOARD = WebServices.URL_LIST_DASHBOARD_EMISOR;
    URL_LIST_DASHBOARD_UNITARIO = WebServices.URL_LIST_DASHBOARD_UNITARIO_EMISOR;


    constructor(private jwtUtil: UtilConfig, private http: Http) {
    }

    search(filtroAux: any, rangeDates: Date[]): Observable<any> {
        let filtro = JSON.parse(JSON.stringify(filtroAux));
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_LIST_LOG;
        if (filtro.document == "-1")
            filtro.document = null;
        let body = JSON.stringify({
            criterio: filtro.search,
            status: filtro.estadoRegistro,
            tipoFecha: filtro.tipoFecha,
            fechaDesde: rangeDates[0],
            fechaHasta: rangeDates[1],
            documentType: filtro.document,
            moneda: filtro.moneda,
            montoMin: (filtro.rangoMontoMin == "") ? null : filtro.rangoMontoMin,
            montoMax: (filtro.rangoMontoMax == "") ? null : filtro.rangoMontoMax,
            consecutivoMin: (filtro.rangoMinConsecutivo == "") ? null : filtro.rangoMinConsecutivo,
            consecutivoMax: (filtro.rangoMaxConsecutivo == "") ? null : filtro.rangoMaxConsecutivo,
            serie: (filtro.numeroSerie == "") ? null : filtro.numeroSerie

        });
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        var prueba = this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtUtil.setJwtToken(res.json().token);
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return prueba
    }

    dashboardGeneral(emisor: string, rangeDates: Date[]): Observable<any> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_LIST_DASHBOARD;
        let body = JSON.stringify({idEmpresa: emisor, fechaDesde: rangeDates[0], fechaHasta: rangeDates[1]});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        var prueba = this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtUtil.setJwtToken(res.json().token);
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return prueba
    }

    dashboardUnitarios(emisor: string, rangeDates: Date[], type: string): Observable<any> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_LIST_DASHBOARD_UNITARIO;
        let body = JSON.stringify({
            idEmpresa: emisor,
            fechaDesde: rangeDates[0],
            fechaHasta: rangeDates[1],
            documentType: type
        });
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        var prueba = this.http.post(url, body, {headers: headers})
            .map(res => {
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return prueba
    }

    getLogEmisor(idParam: number): Observable<LogEmisor> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_GET_LOG;
        let logVar = {id: idParam};
        let body = JSON.stringify({log: logVar});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        var log = this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtUtil.setJwtToken(res.json().token);
                let item = res.json().log;
                if (item) {
                    var respuesta;
                    if (item.respuesta.length <= 0) {
                        respuesta = "EN PROCESO";
                    } else {
                        respuesta = (item.respuesta[0].responseCode == 0) ? "ACEPTADA" : "RECHAZADA";
                    }
                    return new LogEmisor(item.id,
                        item.requestDate,
                        item.requestType,
                        item.documentType,
                        item.numRuc,
                        item.requestAddress,
                        item.username,
                        item.password,
                        item.ticket,
                        item.fileName,
                        item.fileContent,
                        item.respuesta,
                        respuesta,
                        item.customer,
                        item.fechaEmisionCPE);
                }
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return log;
    }

    getCombos(): Observable<any> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_GET_COMBOS;
        let body = JSON.stringify({});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        var combos = this.http.post(url, body, {headers: headers})
            .map(res => {
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return combos;
    }


}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/logEmisor/recursos/servicios/logEmisor.service.ts